export interface VideoItem {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  duration: string;
  views: number;
  category: string;
  categorySlug: string;
  tags: string[];
  date: string;
  rating: number;
  isHot: boolean;
  isNew: boolean;
  content: string;
  relatedVideos: string[];
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '探索深海奥秘：世界最深海沟的未知生物',
    description: '跟随深海探测器，潜入世界最深的马里亚纳海沟，发现那些从未被人类见过的神秘深海生物，感受大自然的神奇与壮丽。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20exploration%20scene%20with%20bioluminescent%20creatures%20in%20dark%20blue%20water%2C%20submarine%20lights%20illuminating%20strange%20deep%20sea%20fish%2C%20mysterious%20atmosphere%2C%20cinematic%20underwater%20photography%2C%20dramatic%20lighting%20from%20above%2C%20minimal%20composition&width=800&height=450&seq=video-thumb-001&orientation=landscape',
    duration: '48:32',
    views: 1285000,
    category: '纪录片',
    categorySlug: 'documentary',
    tags: ['深海', '自然', '探索', '科学'],
    date: '2026-08-01',
    rating: 9.6,
    isHot: true,
    isNew: false,
    content: '在这部震撼人心的深海纪录片中，我们跟随国际科考队深入马里亚纳海沟...',
    relatedVideos: ['v002', 'v003', 'v004', 'v005'],
  },
  {
    id: 'v002',
    title: '从零开始学编程：Python入门完全指南',
    description: '专为编程初学者打造的Python入门课程，从环境搭建到实战项目，手把手带你进入编程世界，轻松掌握Python核心知识。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20coding%20workspace%20with%20laptop%20showing%20Python%20code%20on%20screen%2C%20warm%20desk%20lamp%20lighting%2C%20clean%20minimal%20setup%2C%20educational%20technology%20aesthetic%2C%20soft%20ambient%20light%2C%20professional%20yet%20inviting%20atmosphere&width=800&height=450&seq=video-thumb-002&orientation=landscape',
    duration: '1:25:10',
    views: 896000,
    category: '教育',
    categorySlug: 'education',
    tags: ['Python', '编程', '入门', '教程'],
    date: '2026-07-28',
    rating: 9.4,
    isHot: true,
    isNew: false,
    content: '本课程将从零开始，带你逐步掌握Python编程的核心概念...',
    relatedVideos: ['v001', 'v003', 'v004', 'v006'],
  },
  {
    id: 'v003',
    title: '舌尖上的中国味道：川菜经典回锅肉',
    description: '正宗川菜大师亲授回锅肉制作秘诀，从选肉到火候，每一个细节都关乎成败，让你在家也能做出地道川味美食。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20twice-cooked%20pork%20dish%20on%20wooden%20table%2C%20steaming%20hot%20food%20photography%2C%20warm%20kitchen%20lighting%2C%20traditional%20Chinese%20cooking%20scene%2C%20garnished%20with%20green%20onions%2C%20authentic%20Sichuan%20cuisine%20presentation&width=800&height=450&seq=video-thumb-003&orientation=landscape',
    duration: '22:15',
    views: 2150000,
    category: '美食',
    categorySlug: 'food',
    tags: ['美食', '川菜', '回锅肉', '烹饪'],
    date: '2026-08-05',
    rating: 9.8,
    isHot: true,
    isNew: true,
    content: '回锅肉是川菜中最具代表性的菜肴之一...',
    relatedVideos: ['v001', 'v002', 'v005', 'v007'],
  },
  {
    id: 'v004',
    title: '宇宙的边界：人类能走多远？',
    description: '顶尖天体物理学家带你探索宇宙的终极奥秘，从大爆炸到黑洞，从暗物质到多重宇宙，一次震撼心灵的宇宙之旅。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20outer%20space%20scene%20with%20colorful%20nebula%20and%20distant%20galaxies%2C%20stars%20scattered%20across%20the%20cosmos%2C%20deep%20purple%20and%20gold%20cosmic%20dust%2C%20awe-inspiring%20astronomical%20photography%2C%20minimalist%20composition&width=800&height=450&seq=video-thumb-004&orientation=landscape',
    duration: '55:20',
    views: 1670000,
    category: '科技',
    categorySlug: 'tech',
    tags: ['宇宙', '天文', '物理', '科普'],
    date: '2026-07-20',
    rating: 9.7,
    isHot: true,
    isNew: false,
    content: '从地球上仰望星空的那一刻起，人类就开始了对宇宙的无尽探索...',
    relatedVideos: ['v002', 'v005', 'v006', 'v008'],
  },
  {
    id: 'v005',
    title: '30天健身挑战：在家练出完美身材',
    description: '无需任何器械，每天只需20分钟，跟着专业教练完成30天全身塑形计划，帮你在这个夏天拥有理想身材。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20modern%20home%20fitness%20space%20with%20yoga%20mat%20and%20dumbbells%2C%20natural%20sunlight%20streaming%20through%20large%20window%2C%20clean%20minimalist%20interior%2C%20healthy%20lifestyle%20aesthetic%2C%20warm%20wooden%20floor%2C%20energetic%20morning%20atmosphere&width=800&height=450&seq=video-thumb-005&orientation=landscape',
    duration: '35:40',
    views: 3420000,
    category: '健身',
    categorySlug: 'fitness',
    tags: ['健身', '运动', '减肥', '塑形'],
    date: '2026-08-03',
    rating: 9.5,
    isHot: true,
    isNew: true,
    content: '这套30天健身计划专为在家锻炼设计...',
    relatedVideos: ['v003', 'v004', 'v007', 'v009'],
  },
  {
    id: 'v006',
    title: '摄影入门：如何拍出惊艳的旅行照片',
    description: '资深旅行摄影师分享构图、光线、后期处理的核心技巧，让你的旅行照片从平庸变惊艳，记录旅途中最美的瞬间。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20camera%20on%20tripod%20overlooking%20mountain%20sunset%20landscape%2C%20golden%20hour%20warm%20light%2C%20travel%20photography%20scene%2C%20breathtaking%20nature%20view%2C%20adventure%20photography%20aesthetic%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-006&orientation=landscape',
    duration: '28:50',
    views: 756000,
    category: '教育',
    categorySlug: 'education',
    tags: ['摄影', '旅行', '技巧', '教程'],
    date: '2026-07-15',
    rating: 9.3,
    isHot: false,
    isNew: false,
    content: '旅行摄影最重要的是捕捉当下的感觉和氛围...',
    relatedVideos: ['v002', 'v004', 'v008', 'v010'],
  },
  {
    id: 'v007',
    title: '古典音乐鉴赏：贝多芬第九交响曲深度解析',
    description: '音乐学者带你逐乐章解读贝多芬第九交响曲，理解这部人类音乐史上的巅峰之作背后的故事与艺术价值。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20symphony%20orchestra%20performing%20on%20stage%2C%20warm%20golden%20spotlight%20illuminating%20musicians%2C%20classical%20music%20concert%20atmosphere%2C%20grand%20concert%20hall%20with%20rich%20wooden%20interior%2C%20dramatic%20yet%20refined%20lighting&width=800&height=450&seq=video-thumb-007&orientation=landscape',
    duration: '42:18',
    views: 523000,
    category: '音乐',
    categorySlug: 'music',
    tags: ['古典音乐', '贝多芬', '交响曲', '鉴赏'],
    date: '2026-07-10',
    rating: 9.6,
    isHot: false,
    isNew: false,
    content: '贝多芬第九交响曲被誉为人类音乐史上最伟大的作品之一...',
    relatedVideos: ['v003', 'v005', 'v009', 'v011'],
  },
  {
    id: 'v008',
    title: '世界建筑奇迹：从金字塔到现代摩天大楼',
    description: '纵览人类建筑史上的伟大奇迹，从古埃及金字塔到迪拜哈利法塔，一部建筑演变的视觉史诗。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Iconic%20architectural%20landmarks%20collage%20with%20ancient%20pyramids%20and%20modern%20skyscrapers%2C%20warm%20desert%20sunset%20lighting%2C%20dramatic%20sky%2C%20architectural%20photography%2C%20clean%20composition%20with%20strong%20geometric%20lines&width=800&height=450&seq=video-thumb-008&orientation=landscape',
    duration: '50:05',
    views: 912000,
    category: '纪录片',
    categorySlug: 'documentary',
    tags: ['建筑', '历史', '文化', '纪录片'],
    date: '2026-06-25',
    rating: 9.5,
    isHot: false,
    isNew: false,
    content: '建筑是人类文明的活化石，记录着每个时代的智慧与梦想...',
    relatedVideos: ['v004', 'v006', 'v010', 'v012'],
  },
  {
    id: 'v009',
    title: '5分钟冥想入门：缓解焦虑释放压力',
    description: '专业冥想导师引导你进行5分钟的正念冥想练习，帮助缓解日常焦虑和工作压力，找回内心的平静与力量。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20space%20with%20candles%20and%20soft%20cushions%2C%20gentle%20morning%20sunlight%20filtering%20through%20sheer%20curtains%2C%20minimalist%20zen%20interior%2C%20calm%20and%20serene%20atmosphere%2C%20warm%20neutral%20tones&width=800&height=450&seq=video-thumb-009&orientation=landscape',
    duration: '12:30',
    views: 1890000,
    category: '健康',
    categorySlug: 'health',
    tags: ['冥想', '减压', '心理健康', '正念'],
    date: '2026-08-06',
    rating: 9.7,
    isHot: true,
    isNew: true,
    content: '在这个快节奏的时代，学会放松和冥想比以往任何时候都更加重要...',
    relatedVideos: ['v005', 'v007', 'v011', 'v001'],
  },
  {
    id: 'v010',
    title: '游戏史话：从像素方块到虚拟现实',
    description: '回顾电子游戏四十年的发展历程，从雅达利到PS5，从8-bit到4K光追，见证游戏产业的惊人进化。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Retro%20gaming%20setup%20with%20classic%20arcade%20cabinet%20and%20modern%20gaming%20console%20side%20by%20side%2C%20neon%20purple%20and%20cyan%20lighting%2C%20nostalgic%20game%20room%20atmosphere%2C%20pixel%20art%20aesthetic%20blended%20with%20modern%20design&width=800&height=450&seq=video-thumb-010&orientation=landscape',
    duration: '38:15',
    views: 1450000,
    category: '游戏',
    categorySlug: 'gaming',
    tags: ['游戏', '电竞', '历史', '娱乐'],
    date: '2026-07-01',
    rating: 9.4,
    isHot: true,
    isNew: false,
    content: '电子游戏从诞生至今，已经走过了四十多年的历程...',
    relatedVideos: ['v006', 'v008', 'v012', 'v002'],
  },
  {
    id: 'v011',
    title: '极光之旅：冰岛追光全攻略',
    description: '跟随旅行博主深入冰岛，在最极致的自然环境中追寻北极光，分享最佳的观极光地点、时间和拍摄技巧。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20aurora%20borealis%20dancing%20over%20Iceland%20snowy%20landscape%2C%20green%20and%20purple%20lights%20in%20night%20sky%2C%20silhouette%20of%20mountains%2C%20magical%20winter%20scene%2C%20breathtaking%20nature%20photography%2C%20dreamy%20atmosphere&width=800&height=450&seq=video-thumb-011&orientation=landscape',
    duration: '30:45',
    views: 670000,
    category: '旅游',
    categorySlug: 'travel',
    tags: ['极光', '冰岛', '旅行', '攻略'],
    date: '2026-06-15',
    rating: 9.6,
    isHot: false,
    isNew: false,
    content: '冰岛是地球上最适合观赏北极光的地方之一...',
    relatedVideos: ['v007', 'v009', 'v001', 'v003'],
  },
  {
    id: 'v012',
    title: 'AI人工智能：改变世界的十大技术突破',
    description: '盘点2026年最令人兴奋的AI技术突破，从大语言模型到机器人技术，看看AI如何重塑我们的未来生活。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20visualization%20with%20glowing%20neural%20network%20patterns%2C%20clean%20white%20and%20warm%20amber%20color%20scheme%2C%20abstract%20digital%20brain%20concept%2C%20minimalist%20tech%20aesthetic%2C%20sophisticated%20and%20modern%20design&width=800&height=450&seq=video-thumb-012&orientation=landscape',
    duration: '45:00',
    views: 2780000,
    category: '科技',
    categorySlug: 'tech',
    tags: ['AI', '人工智能', '科技', '未来'],
    date: '2026-08-07',
    rating: 9.8,
    isHot: true,
    isNew: true,
    content: '2026年是人工智能技术爆发的一年...',
    relatedVideos: ['v008', 'v010', 'v002', 'v004'],
  },
];

export const getTrendingVideos = (): VideoItem[] => {
  return videos.filter(v => v.isHot).sort((a, b) => b.views - a.views).slice(0, 8);
};

export const getLatestVideos = (): VideoItem[] => {
  return [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 12);
};

export const getVideosByCategory = (slug: string): VideoItem[] => {
  return videos.filter(v => v.categorySlug === slug);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find(v => v.id === id);
};